// src/components/shared/ApiKeyMissing.tsx
// Placeholder card shown when a backend API key is not configured.

import { AlertTriangle } from 'lucide-react';

export function ApiKeyMissing({ service }: { service: string }) {
  return (
    <div className="o-card border border-amber-500/30 p-8 text-center">
      <AlertTriangle size={32} className="mx-auto mb-3 text-amber-600 dark:text-amber-400" />
      <p className="text-foreground/80 font-semibold">API Key no configurada</p>
      <p className="text-sm text-muted-foreground mt-1">
        El servicio <strong>{service}</strong> requiere una API key en el backend.
        Contacta a tu administrador para configurar la variable de entorno correspondiente.
      </p>
    </div>
  );
}
